module.exports = __webpack_public_path__ + "media/images/vedett_allatok/vedett1-6d964602123753cc865661a911ab622c.jpg";